import type { ElementType } from 'react'

import { ArrowDownIcon } from '../Icons/Navigational/ArrowDown'
import { ArrowLeftIcon } from '../Icons/Navigational/ArrowLeft'
import { ArrowRightIcon } from '../Icons/Navigational/ArrowRight'
import { ArrowUpIcon } from '../Icons/Navigational/ArrowUp'
import { ChevronDownIcon } from '../Icons/Navigational/ChevronDown'
import { ChevronLeftIcon } from '../Icons/Navigational/ChevronLeft'
import { ChevronLeftThinIcon } from '../Icons/Navigational/ChevronLeftThin'
import { ChevronRightIcon } from '../Icons/Navigational/ChevronRight'
import { ChevronUpIcon } from '../Icons/Navigational/ChevronUp'
import { CrossIcon } from '../Icons/Navigational/Cross'
import { MinusIcon } from '../Icons/Navigational/Minus'
import { PlusIcon } from '../Icons/Navigational/Plus'

export const linkIconMapper: Record<string, ElementType> = {
  arrowDown: ArrowDownIcon,
  arrowUp: ArrowUpIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronDown: ChevronDownIcon,
  chevronUp: ChevronUpIcon,
  chevronLeftThinIcon: ChevronLeftThinIcon,
  minus: MinusIcon,
  plus: PlusIcon,
  cross: CrossIcon,
}

export const linkStyles = [
  'sb-text-body-default-regular',
  'sb-text-body-default-strong',
  'sb-text-interface-body-small-regular',
  'sb-text-body-small-regular',
  'sb-text-interface-body-x-small-regular',
  'sb-text-heading-small',
  'sb-text-heading-medium',
  'sb-text-interface-body-small-strong',
]

const hasEncodedChars = (str: string): boolean => {
  const encodedCharRegex = /%[0-9A-Fa-f]{2}/

  return encodedCharRegex.test(str)
}

export const validateHrefHostname = (href?: string) => {
  const nonHttpProtocols = ['mailto:', 'tel:', 'sms:', 'whatsapp:', 'skype:']

  if (!href || typeof href !== 'string') {
    return false
  }

  if (
    (href.startsWith('/') && !href.startsWith('//')) ||
    href.startsWith('#')
  ) {
    return true
  }

  if (nonHttpProtocols.some((protocol) => href.startsWith(protocol))) {
    return true
  }

  try {
    const urlString = href.startsWith('//') ? `https:${href}` : href
    const url = new URL(urlString)

    return !hasEncodedChars(url.hostname)
  } catch (error) {
    return false
  }
}
